import { Component, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { BehaviorSubject ,  Subscription } from 'rxjs';

import { MigalhasService } from 'app/shared/migalhas/migalhas.service';
//import { AREAS } from './especializacao/shared/areas';

import { Migalha } from 'models/migalha';
import { environment } from 'environments/environment';
// import { link } from 'fs';

@Component({
  selector: 'app-pos-graduacao',
  templateUrl: './pos-graduacao.component.html',
  styleUrls: ['./pos-graduacao.component.scss'],
})
export class PosGraduacaoComponent implements OnDestroy {
  url: BehaviorSubject<string> = new BehaviorSubject<string>('');
  routerObserver;
  migalhas: Migalha[];
  migalhasObs: Subscription;
  shouldHaveSideMenu: Boolean = true;
  isStricto: Boolean = true;

  baseMenuLateral = {
    "CEUMA":{
      nome: 'Pós-Graduação',
      link: '/pos-graduacao',
      nomeMigalha: 'Pós-graduação'
    },"EURO":{
      nome: 'Pós-Graduação',
      link: '/pos-graduacao',
      nomeMigalha: 'Pós-graduação'
    },"FAMAZ":{
      nome: 'Pós-Graduação',
      link: '/pos-graduacao',
      nomeMigalha: 'Pós-graduação'
    },
  };


//TO-DO Voltar para oque era antes
menuLateralStrictoSensu =
(environment.loginContexto==='CEUMA')?
  [
    {
      nome: 'Doutorado',
      link: '/pos-graduacao/doutorado',
      submenu: [
        { nome: 'Odontologia', link: '/pos-graduacao/doutorado/2239-odontologia' },
        { nome: 'Biodiversidade e Biotecnologia', link: '/pos-graduacao/doutorado/9999-biodiversidade-e-biotecnologia---rede-bionorte/' },
        { nome: 'Educação em Ciências e Matemática', link: '/pos-graduacao/doutorado/9991-educacao-em-ciencias-e-matematica---rede-reamec/' },
        { nome: 'Meio Ambiente', link: '/pos-graduacao/doutorado/1962-meio-ambiente/sobre-o-programa' },
      ],
    },{
      nome: 'Mestrado',
      link: '/pos-graduacao/mestrado',
      submenu: [
        { nome: 'Gestão de Programas e Serviços de Saúde', link: '/pos-graduacao/mestrado/1385-gestao-de-programas' },
        { nome: 'Meio Ambiente', link: '/pos-graduacao/mestrado/1963-meio-ambiente' },
        { nome: 'Biologia Microbiana', link: '/pos-graduacao/mestrado/2870-biologia-microbiana' },
        { nome: 'Odontologia', link: '/pos-graduacao/mestrado/0231-odontologia' },
        { nome: 'Direito', link: '/pos-graduacao/mestrado/3152-direito-e-afirmacao-de-vulneraveis/sobre-o-programa' },
      ],
    }
  ]:[
    {
      nome: 'Pós-graduação',
      link: '/pos-graduacao/pos-graduacao',
    },
    {
      nome: 'Pós-Médica',
      link: '/pos-graduacao/pos-med'
    }
  ]

menuLateralLatoSensu = [
  {
    nome: 'Pos-graduacao',
    link: '/pos-graduacao/especializacao'
  },

];

menuLateral = [this.menuLateralStrictoSensu[0],this.menuLateralStrictoSensu[1],this.menuLateralLatoSensu[0]];

  constructor(
    private router: Router,
    private migalhasService: MigalhasService,
  ) {
    //console.log(router.url);
    switch(router.url){
      case '/pos-graduacao/mestrado'||'/pos-graduacao/doutorado':
        //this.menuLateral = this.menuLateralStrictoSensu;
        this.baseMenuLateral[environment.loginContexto].nome = 'Pós-Graduação Stricto Sensu';
        break;
      case '/pos-graduacao/especializacao':
        //this.menuLateral = this.menuLateralLatoSensu;
        this.baseMenuLateral[environment.loginContexto].nome = 'Pós-Graduação Lato Sensu';
        break;
    }
    //console.log(this.menuLateral);
    let migalhaRaiz = new Migalha(this.baseMenuLateral);
    migalhaRaiz.nome = this.baseMenuLateral[environment.loginContexto].nomeMigalha;
    migalhaRaiz.submenu = Migalha.construirArray(this.menuLateral);

    this.migalhasObs = this.migalhasService
      .iniciar([migalhaRaiz])
      .subscribe((dados) => {
        this.migalhas = dados;
      });

    let url = '';
    this.routerObserver = router.events.subscribe((evento) => {
      if (evento instanceof NavigationEnd) {
        url = evento.urlAfterRedirects || evento.url;
        this.url.next(url);
        this.migalhasService.novaUrl(url);
        this.shouldHaveSideMenu = this.updateShowSideMenu(url);
      }

    });
    this.url = new BehaviorSubject<string>(url);
  }

  ngOnDestroy() {
    if (this.routerObserver) {
      this.routerObserver.unsubscribe();
    }

    if (this.migalhasObs) {
      this.migalhasObs.unsubscribe();
    }
  }

  private updateShowSideMenu(url: String) {
    switch(url){
      case '/pos-graduacao/mestrado': case '/pos-graduacao/doutorado':
        //this.menuLateral = this.menuLateralStrictoSensu;
        this.baseMenuLateral[environment.loginContexto].nome = 'Pós-Graduação Stricto Sensu';
        this.isStricto = true;
        break;
      case '/pos-graduacao/especializacao':
        //this.menuLateral = this.menuLateralLatoSensu;
        this.baseMenuLateral[environment.loginContexto].nome = 'Pós-Graduação Lato Sensu';
        this.isStricto = false;
        break;
    }
    return this.menuLateral.some(
      item => this.findLinkOnItemMenu(item, url)
    );
  }

  private findLinkOnItemMenu(item, url) {
    //console.log(item);
    //console.log(url);
    if (item.link === url) {
      return true;
    } else if (item.submenu && item.submenu.length) {
      return item.submenu.some(itemSubmenu => this.findLinkOnItemMenu(itemSubmenu, url));
    }
    return false;
  }
}
